import { render, staticRenderFns } from "./CalendarEventEditorEmployeeSelectorDialog.vue?vue&type=template&id=0c8071be&scoped=true&lang=pug&"
import script from "./CalendarEventEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventEditorEmployeeSelectorDialog.vue?vue&type=style&index=0&id=0c8071be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8071be",
  null
  
)

export default component.exports